'use strict';

require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es7.string.pad-end");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.array.map");
require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssSerializer = undefined;
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _moment = require('moment');
var _moment2 = _interopRequireDefault(_moment);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function serializeKeyValue(json, key) {
  return key + ': ' + json[key];
}
var AssSerializer = exports.AssSerializer = function () {
  function AssSerializer() {
    _classCallCheck(this, AssSerializer);
  }
  _createClass(AssSerializer, null, [{
    key: 'serialize',
    value: function serialize(json) {
      return AssSerializer.serializeHeaderInfo(json) + AssSerializer.serializeV4Styles(json) + AssSerializer.serializeEvents(json);
    }
  }, {
    key: 'serializeHeaderInfo',
    value: function serializeHeaderInfo(json) {
      var info = json.info;
      return '[Script Info]\n' + serializeKeyValue(info, 'Title') + '\n' + serializeKeyValue(info, 'ScriptType') + '\n' + serializeKeyValue(info, 'WrapStyle') + '\n' + serializeKeyValue(info, 'PlayResX') + '\n' + serializeKeyValue(info, 'PlayResY') + '\n' + serializeKeyValue(info, 'ScaledBorderAndShadow') + '\n' + serializeKeyValue(info, 'Last Style Storage') + '\n' + serializeKeyValue(info, 'Video File') + '\n' + serializeKeyValue(info, 'Video Aspect Ratio') + '\n' + serializeKeyValue(info, 'Video Zoom') + '\n' + serializeKeyValue(info, 'Video Position') + '\n\n';
    }
  }, {
    key: 'serializeV4Styles',
    value: function serializeV4Styles(json) {
      var v4Styles = json.styles;
      return '[V4+ Styles]\nFormat: ' + v4Styles.format.join(', ') + '\n' + v4Styles.style.map(function (s) {
        return 'Style: ' + s.join(',');
      }).join('\n') + '\n\n';
    }
  }, {
    key: 'serializeEvents',
    value: function serializeEvents(json) {
      var events = json.events;
      return '[Events]\nFormat: ' + events.format.join(', ') + '\n' + events.comment.map(function (d) {
        return AssSerializer.serializeComment(d);
      }).join('\n') + '\n' + (events.dialogue ? events.dialogue.map(function (d) {
        return AssSerializer.serializeDialogue(d);
      }).join('\n') + '\n' : '');
    }
  }, {
    key: 'serializeTime',
    value: function serializeTime(number) {
      var milli = String(number).split('.')[1];
      return (0, _moment2["default"])().startOf('day').seconds(number).format('H:mm:ss') + '.' + (milli || '').padEnd(2, '0');
    }
  }, {
    key: 'serializeDialogueItem',
    value: function serializeDialogueItem(d) {
      return d.Layer + ',' + AssSerializer.serializeTime(d.Start) + ',' + AssSerializer.serializeTime(d.End) + ',' + (d.Style ? d.Style : '') + ',' + (d.Name ? d.Name : '') + ',' + String(d.MarginL).padStart(4, '0') + ',' + String(d.MarginR).padStart(4, '0') + ',' + String(d.MarginV).padStart(4, '0') + ',' + (d.Effect ? d.Effect : '') + ',' + d.Text.raw;
    }
  }, {
    key: 'serializeDialogue',
    value: function serializeDialogue(d) {
      return 'Dialogue: ' + AssSerializer.serializeDialogueItem(d);
    }
  }, {
    key: 'serializeComment',
    value: function serializeComment(d) {
      return 'Comment: ' + AssSerializer.serializeDialogueItem(d);
    }
  }]);
  return AssSerializer;
}();
exports["default"] = AssSerializer;